import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '40vh',
      display: 'flex',
      flexDirection: 'column',
    },
    titleContainer: {
      padding: `${theme.spacing(0.5)}px ${theme.spacing(3)}px`,
      display: 'flex',
      alignItems: 'center',
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
      justifyContent: 'space-between',
      width: '100%',
      maxWidth: '100%',

      '& > *:first-child': {
        width: '100%',
        flex: 1,
      },
    },
    similarSchools: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    controlLabelRoot: {
      marginRight: 0,
      userSelect: 'none',
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: `${theme.spacing(1.25)}px ${theme.spacing(3)}px`,
    },
    buttonSeeMore: {
      minWidth: 'fit-content',
      maxWidth: 'fit-content',
      marginTop: theme.spacing(0.4),
    },
    indicatorRenderContainer: {
      marginTop: theme.spacing(2),
      transform: `translateX(-${theme.spacing(1.75)}px)`,
      width: `calc(100% + ${theme.spacing(1.75)}px)`,
    },
    icon: {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
      }),

      '&.open': {
        transform: 'rotate(180deg) translateY(2px)',
      },
    },
    navigationContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(3),

      '& > * + *': {
        marginLeft: theme.spacing(3),
      },

      '& > h6': {
        userSelect: 'none',
      },
    },
    navigationButton: {
      textTransform: 'none',
    },
    navigationText: {
      minWidth: 140,
      textAlign: 'center',
    },
    pageTitle: {
      fontWeight: 600,
    },
    indicatorEventTitle: {
      fontWeight: 'bold',
      marginBottom: theme.spacing(0.6),
    },
  }),
);
